import React from "react";
import Breadcrumb from "../../common/components/Breadcrumb";
import CenteredLoader from "../../common/components/CenteredLoader";
import { Select } from "../../common/components/Form/Select";
import { Button } from "../../common/components/Form/Button";
import { FormErrorsSchema } from "../../common/types";

export const RESULT_OPTIONS = [
  { value: "", label: "Select an option" },
  { value: "fertile", label: "Positive (Sperm Detected)" },
  { value: "notFertileNoSperm", label: "Negative (No Sperm Detected)" },
  { value: "notFertileNonMotile", label: "Negative (Non-motile Sperm)" },
  { value: "error", label: "Error" },
];

interface ResultFormLayoutProps {
  serialNumber?: string;
  heading: string;
  primaryLabel: string;
  selectedOption: string;
  setSelectedOption: (value: string) => void;
  formErrors: FormErrorsSchema;
  loading: boolean;
  onSubmit: () => Promise<void>;
  onCancel: () => void;
  onChangeOption?: (newValue: string, sourceName: string) => void;
  topContent?: React.ReactNode;
}

const ResultFormLayout: React.FC<ResultFormLayoutProps> = ({
  serialNumber,
  heading,
  primaryLabel,
  selectedOption,
  setSelectedOption,
  formErrors,
  loading,
  onSubmit,
  onCancel,
  onChangeOption,
  topContent,
}) => {
  const handlePrimaryClick = async () => {
    if (selectedOption.length > 0) {
      await onSubmit();
    }
  };

  return (
    <div className="w-full lg:w-2/3 min-h-screen bg-gray-100 text-gray-900">
      <main className="mx-auto px-4 sm:px-6 lg:px-8 pt-4">
        {topContent}

        <Breadcrumb
          pages={[
            { name: "Lab's portal", href: "#", current: false },
            { name: "Result registration", href: "#", current: false },
            {
              name: serialNumber ? `Semen analysis kit ${serialNumber}` : "Semen analysis kit",
              href: "#",
              current: true,
            },
          ]}
        />

        <div className="mt-8">
          <h1 className="text-xl font-semibold">
            {heading}
          </h1>
        </div>

        {loading && (
          <div className="w-full bg-white mt-6 p-6">
            <CenteredLoader className="flex mt-12 mb-12" />
          </div>
        )}

        {!loading && (
          <div className="bg-white mt-6 p-6">
            <div className="w-full mt-6">
              <Select
                label="Result"
                name="result"
                options={RESULT_OPTIONS}
                value={selectedOption}
                setValue={setSelectedOption}
                errors={formErrors}
                onChange={onChangeOption}
              />
            </div>
            <div className="w-full mt-6 mb-6 md:mb-16">
              <Button
                label={primaryLabel}
                theme="primary"
                size="medium"
                className="block w-full mb-4 md:float-right md:ml-auto md:w-auto md:ml-4 mb:mb-0"
                disabled={selectedOption.length === 0}
                onClick={handlePrimaryClick}
              />
              <Button
                label="Cancel"
                theme="secondary"
                size="medium"
                className="block w-full md:float-right md:ml-auto md:w-auto"
                onClick={onCancel}
              />
            </div>
          </div>
        )}
      </main>
    </div>
  );
};

export default ResultFormLayout;

